module.exports = __webpack_public_path__ + "static/media/user.5e946c20.svg";